<template>
  <!-- Mobile only: replaces the RegLayout logo header and the page title (see route meta `mobileHero`). -->
  <section class="regMobileHero">
    <div class="regMobileHeroBar">
      <router-link :to="{ name: 'homepage' }">
        <img src="@/assets/imgs/web/weblogo.png" alt="AlUla Logo" class="regMobileHeroLogo">
      </router-link>
      <span class="regMobileHeroPill regMobileHeroPillStrong">{{ edition }}</span>
    </div>
    <div class="regMobileHeroTitles">
      <h1 class="regMobileHeroTitle">{{ title }}</h1>
      <p class="regMobileHeroSub">{{ subtitle }}</p>
    </div>
  </section>
</template>

<script>
import { CONFERENCE_TITLE, CONFERENCE_SUBTITLE, CONFERENCE_EDITION } from '@/utils/conference';

export default {
  name: 'RegMobileHero',
  data() {
    return {
      title: CONFERENCE_TITLE,
      subtitle: CONFERENCE_SUBTITLE,
      edition: CONFERENCE_EDITION,
    };
  },
};
</script>

<style scoped>
.regMobileHero{
  display: none;
}
@media all and (max-width:768px) {
  .regMobileHero{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 16px 16px 24px;
    text-align: left;
    background: linear-gradient(rgba(63, 36, 22, 0.55), rgba(63, 36, 22, 0.55)), url('@/assets/imgs/web/alula_main_banner.jpg') center / cover no-repeat;
  }
}
.regMobileHeroBar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 56px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.1);
}
.regMobileHeroLogo{
  display: block;
  height: 44px;
  width: auto;
}
.regMobileHeroPill{
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.125);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  color: var(--white);
  font-size: 11px;
  font-weight: 600;
  line-height: 13px;
}
.regMobileHeroPillStrong{
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.25);
  font-weight: 700;
}
.regMobileHeroTitles{
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.regMobileHeroTitle{
  font-family: var(--preRegHeadingFont);
  color: var(--white);
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
}
.regMobileHeroSub{
  color: rgba(255, 255, 255, 0.87);
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  white-space: pre-line;
}
</style>
